import { Component, HostListener, Input, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { J4uV1Service } from 'abs-ngx-library/src/lib/core';
import { LaunchpadService } from 'src/app/shared/services/launchpad.service';
import { LogService } from 'src/app/shared/services/log.service';
import  {properties}  from 'src/environments/properties';

@Component({
  selector: 'app-deals-hub',
  templateUrl: './deals-hub.component.html',
  styleUrls: ['./deals-hub.component.scss']
})
export class DealsHubComponent implements OnInit {
  @Input() isBonusPath: boolean = false;
  public _window: any = window;
  public enableDealsHub: boolean = true;
  public banner: string = '';
  public launchpadData: any;
  public tileContent: any = [];
  public lifetimeSavingsData: any;
  public ABTestFlag: string = "";
  public showDealsHub: boolean = true;
  public secondsCounter: number = 0;
  public rewardsBalance: number = 0;
  public smallScreen = window.innerWidth < 992;
  private wwwHost: any;

  @HostListener('window:resize', ['$event'])
  onResize() {
    const oldSmallScreen = this.smallScreen;
    this.smallScreen = window.innerWidth < 992;
    if (oldSmallScreen !== this.smallScreen) {
      this.findReBrandingTile();
    }
  }

  constructor(
    private launchPadService: LaunchpadService,
    private _logService: LogService,
    private _j4uAlV1Service: J4uV1Service,
  ) {
    this.banner = this._window['AB']['userInfo']['banner'];
    this.wwwHost = this._window['SWY']?.CONFIGSERVICE?.bannerDomainMap["www-" + this.banner];
  }

  findReBrandingTile() {
    if (this.enableDealsHub) {
      this.tileContent.map((tile: any) => {
        if (/for\s?U\+/i.test(tile.tileHeading)) {
          if (this.smallScreen) {
            if (!tile._originalHeading) {
              tile._originalHeading = tile.tileHeading;
            }
            tile.tileHeading = 'forU+';
          } else if (tile._originalHeading) {
            tile.tileHeading = tile._originalHeading;
          }
        }
      });
    }
  }

  ngOnInit(): void {
    if (this.enableDealsHub) {
      const displayableBannerName: any = properties.displayableBannerNames[this.banner as keyof typeof properties.displayableBannerNames] || this._window['AB']['userInfo']['displayableBanner'];
      if(properties.featureFlags?.freshpassRebranding ?? false) {
        //get launchpad data from local json for freshpass rebranding
        let data = require('src/environments/launchpadcontent.json');
        if(data) {
          if (data['welcomeText'] && data['welcomeText']['headlineSubText']) {
            data['welcomeText']['headlineSubText'] = data['welcomeText']['headlineSubText'].replace('${{banner}}',displayableBannerName);
          }
          this.launchpadData = data;
          this.tileContent = data[this.banner];
          this.findReBrandingTile();
          this.checkSubscriptionTile();
        } else {
          this.launchpadData = undefined;
        }

      } else {
        //TODO: get launchpad data from api, Remove after freshpass rebranding works is finalized
        this.launchPadService.getLaunchpadData().subscribe( (data) => {
          if(data) {
            if (data['welcomeText'] && data['welcomeText']['headlineSubText']) {
              data['welcomeText']['headlineSubText'] = data['welcomeText']['headlineSubText'].replace('${{banner}}',displayableBannerName);
            }
            this.launchpadData = data;
            this.tileContent = data[this.banner];
            this.findReBrandingTile();
            this.checkSubscriptionTile();
          }
        }, error => {
          this.launchpadData = undefined;
        })
      }
      

      const apiPath = this._window['AB'].savingsAPIPath;
      this.launchPadService.getLifetimeSavingsData().subscribe( (data) => {
          if(data) {
              this.lifetimeSavingsData = data['lifetimeSavings'];
          } else {
              this.lifetimeSavingsData = "0.00";
          }
      }, (error) => {
        this.lifetimeSavingsData = "0.00"
      })
      setTimeout(() => this.triggerABFlagLogic(), 3000);
      setTimeout(() => {
        this.launchPadService.getRewardsPointsBalance().subscribe( (data) => {
          this.rewardsBalance = data;
          this.displayRewardTile();
          if(this.lifetimeSavingsData === "0.00") {
            this.launchpadData['welcomeText']['savingsText'] = "";
          }
        }, (err) => {
          this.rewardsBalance = 0;
          this.displayRewardTile();
        })
      }, 3000);
    }
  }

  public checkSubscriptionTile(): void {
    const enableB4UPlusLaunch =
      this._window['SWY']?.CONFIGSERVICE?.featureToggleConfig?.enableB4UPlusLaunch === true;

    if (enableB4UPlusLaunch) {
      this._j4uAlV1Service.getSubscriptionApiData().subscribe(
        (response: any) => {
          const status: string = (response?.Data?.status ?? '').trim().toLowerCase();
          if (status === 'cancelled') {
            this.removeFreshpassTile();
          } else if (response?.Data?.planGeneration?.toUpperCase() === 'B4U_PLUS') {
            this.removeFreshpassTile();
          } else {
            this.removeB4UPlusTile();
          }
        },
        (_err: HttpErrorResponse) => {
          this.removeFreshpassTile();
        }
      );
      return;
    }

    // Launch rolled back (enableB4UPlusLaunch === false): never display the B4U+ pill
    this.removeB4UPlusTile();

    const freshpassPreLaunchEnabled =
      this._window['SWY']?.CONFIGSERVICE?.featureToggleConfig?.disableFreshpassForPreLaunch === true;
    if (!freshpassPreLaunchEnabled) {
      // disableFreshpassForPreLaunch is false or not set — business as usual, show tile as per launchpadcontent.json
      return;
    }
    // disableFreshpassForPreLaunch === true: only show the tile if user is subscribed
    this._j4uAlV1Service.getSubscriptionApiData().subscribe(
      (_response: any) => {
        const status: string = _response?.Data?.status ?? '';
        if (status.toLowerCase() === 'cancelled') {
          this.removeFreshpassTile();
        }
      },
      (_err: HttpErrorResponse) => {
        // Not subscribed — remove the FreshPass tile
        this.removeFreshpassTile();
      }
    );
  }

  private removeFreshpassTile(): void {
    if (this.tileContent && Array.isArray(this.tileContent)) {
      this.tileContent = this.tileContent.filter(
        (tile: any) => tile.tileURL !== '/freshpass/manage/subscribe'
      );
    }
  }

  private removeB4UPlusTile(): void {
    if (this.tileContent && Array.isArray(this.tileContent)) {
      this.tileContent = this.tileContent.filter(
        (tile: any) => tile.tileURL !== '/foruplus'
      );
    }
  }

  public triggerABFlagLogic() {
    if (this._window && this._window["analyticsSwy"] && this._window["analyticsSwy"]["testFlags"] && this._window["analyticsSwy"]["testFlags"]["ACIP96868"]) {
        console.warn('AB Test Flag value is found');
        this.ABTestFlag = this._window["analyticsSwy"]["testFlags"]["ACIP96868"];
        if(this.ABTestFlag && this.ABTestFlag === 'a') {
            this.showDealsHub = false;
        } else if (this.ABTestFlag && this.ABTestFlag === 'b') {
            this.showDealsHub = true;
        }
    } else {
        console.warn('AB Test Flag value is not found');
        this.showDealsHub = true;
    }
  }

  public displayRewardTile() {
    if (this.tileContent && this.tileContent.length) {
        const rewardsTile = this.tileContent.findIndex((tile: any) => (tile.tileHeading === 'Rewards') || (tile.tileHeading === 'Points'));
        if (rewardsTile > -1) {
            this.tileContent[rewardsTile].tileHeading = `${this.rewardsBalance.toLocaleString("en-US")} ${this.tileContent[rewardsTile].tileHeading}`;
        }
    }
  }

  public onTileClick(event: MouseEvent): void {
    const enableForUPlus: boolean = this._window?.SWY?.CONFIGSERVICE?.featureToggleConfig?.enableForUPlus ?? false;
    if (!enableForUPlus) return;
    const anchor = (event.target as HTMLElement).closest('a') as HTMLAnchorElement | null;
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    if ((href === '/foruplus' || href.endsWith('/foruplus')) && this._window?.AB?.DATALAYER) {
      this._window.AB.DATALAYER.analyticsCTATracking('cta:deals|pill|foruplus');
    }
  }

}